import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { createAttachment } from 'action/article'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Form, Modal } from 'antd'
import AttachmentForm from 'view/component/attachment-form'
import FormModal from 'view/component/form-modal'
import PropTypes from 'prop-types'

const { success, error } = Modal

const buildSuccessObject = () => ({
  centered: true,
  content: 'This attachment has been successfully created',
  title: 'New Attachment'
})

const buildErrorObject = () => ({
  centered: true,
  content: 'Please try again.',
  title: 'There has been an issue creating this attachment'
})

const NewAttachment = ({ article, createAttachment, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => setVisible(true)

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await createAttachment({ ...values, article_uuid: article.uuid })
      setVisible(false)
      form.resetFields()
      response ? success(buildSuccessObject()) : error(buildErrorObject())
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>New Attachment</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.resetFields()
        }}
        title='New Attachment'
        visible={visible}
      >
        <AttachmentForm
          allowUpload
          articleUuid={article.uuid}
          form={form}
        />
      </FormModal>
    </>
  )
}

NewAttachment.propTypes = {
  article: PropTypes.object,
  createAttachment: PropTypes.func,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.attachmentSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  createAttachment: bindActionCreators(createAttachment, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(NewAttachment)
